import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { UnitOfWorkService } from '../../services/unitOfWork/unitOfWork.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import * as _util from '../../services/utilities';
import { BusyService } from '../../services/busy.service';

@Component({
  selector: 'app-document',
  templateUrl: './document.component.html',
  styleUrls: ['./document.component.css']
})
export class DocumentComponent implements OnInit, OnDestroy {
    library: string;
    id: number;
    sub: Subscription;
    doc: model.document;

    constructor(private route: ActivatedRoute, private uow: UnitOfWorkService, private busy: BusyService) { }

    ngOnInit() {
        this.sub = this.route.params.subscribe(params => {
            this.library = params["library"];
            this.id = +params["id"];
            this.busy.set({ key: 'document-load', isBusy: true, message: 'Loading Document' });
            this.uow.documentView(this.library, this.id)
                .then((data) => {
                    if (data && data.length) {
                        this.doc = data[0];

                        console.log(this.doc);
                    }
                    this.busy.set({ key: 'document-load', isBusy: false });
                });
        });
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }
}
